<div class="blog-listing-v2 bg-gradient-to-b from-[#fef3ef]">
  <ng-container *ngIf="vm$ | async as vm; else blogSkeleton">
    <section class="bl2-hero">
      <div class="bl2-shell">
        <div class="bl2-hero-grid">
          <div class="bl2-hero-copy">
            <span class="bl2-eyebrow">
              <span class="bl2-eyebrow-dot"></span>
              Good Reads
            </span>
            <h1 class="bl2-hero-heading">
              Insights for<br />modern B2B.<br />Ideas that stick.
            </h1>
            <p class="bl2-hero-sub">
              Strategy, playbooks and real-world GTM stories for revenue teams.
            </p>
          </div>

          <div class="bl2-hero-featured" *ngIf="vm.latestPost as post">
            <div class="bl2-hero-card" (click)="open(post)">
              <app-blog-cover
                [title]="post.title"
                [slug]="post.slug"
                ratio="16 / 9"
              />
              <div class="bl2-card-body">
                <div class="bl2-card-meta">
                  <span class="bl2-meta-date" *ngIf="post.publishedAt">{{
                    post.publishedAt
                  }}</span>
                </div>
                <h3 class="bl2-hero-card-title">{{ post.title }}</h3>
                <p class="bl2-hero-card-excerpt" *ngIf="post.excerpt">
                  {{ post.excerpt }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bl2-filter-bar">
      <!-- <div class="bl2-shell bl2-filter-inner">
        <div class="bl2-filter-left">
          <span class="bl2-filter-label">Search posts</span>
        </div>

        <div class="bl2-filter-search">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            aria-hidden="true"
          >
            <circle
              cx="6.5"
              cy="6.5"
              r="4.5"
              stroke="#9ca3af"
              stroke-width="1.5"
            />
            <path
              d="M10.5 10.5L14 14"
              stroke="#9ca3af"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
          <input
            type="text"
            [formControl]="searchControl"
            placeholder="Search"
            aria-label="Search blog posts"
          />
          <button
            type="button"
            class="bl2-clear-btn"
            *ngIf="searchControl.value"
            (click)="clearSearch()"
            aria-label="Clear search"
          >
            ✕
          </button>
        </div>
      </div> -->
    </section>

    <section class="bl2-section">
      <div class="bl2-shell">
        <!-- <div class="bl2-section-header">
          <h2
            class="bl2-section-title"
            *ngIf="vm.searchResults; else allPostsTitle"
          >
            Results for "{{ vm.query }}"
          </h2>
          <ng-template #allPostsTitle>
            <h2 class="bl2-section-title">All posts</h2>
          </ng-template>
          <button
            type="button"
            class="bl2-clear-results-btn"
            *ngIf="vm.searchResults"
            (click)="clearSearch()"
          >
            Clear
          </button>
        </div> -->

        <ng-container *ngIf="vm.searchResults || vm.allPosts as posts">
          <div class="bl2-grid" *ngIf="posts.length; else noResults">
            <article
              class="bl2-card"
              *ngFor="let post of posts; trackBy: trackBySlug"
              (click)="open(post)"
            >
              <app-blog-cover [title]="post.title" [slug]="post.slug" />
              <div class="bl2-card-body">
                <div class="bl2-card-meta">
                  <span class="bl2-meta-date" *ngIf="post.publishedAt">{{
                    post.publishedAt
                  }}</span>
                </div>
                <h3 class="bl2-card-title">{{ post.title }}</h3>
                <p class="bl2-card-excerpt" *ngIf="post.excerpt">
                  {{ post.excerpt }}
                </p>
                <div class="bl2-card-author" *ngIf="post.author?.name">
                  <img
                    *ngIf="post.author?.profilePic"
                    class="bl2-author-avatar"
                    [src]="post.author.profilePic"
                    [alt]="post.author.name"
                  />
                  <div
                    *ngIf="!post.author?.profilePic"
                    class="bl2-author-avatar-fallback"
                  >
                    {{ post.author.name!.charAt(0) }}
                  </div>
                  <span class="bl2-author-name">{{ post.author.name }}</span>
                </div>
              </div>
            </article>
          </div>

          <ng-template #noResults>
            <p class="bl2-empty">No posts match "{{ vm.query }}".</p>
          </ng-template>
        </ng-container>
      </div>
    </section>

    <div class="bl2-cta-wrap">
      <app-cta-section
        headingStart="Stay ahead with smarter"
        headingGradient="B2B insights."
        description="Connect your LinkedIn Ads account in 2 minutes and start turning data into decisions. No credit card required."
      />
    </div>
  </ng-container>

  <ng-template #blogSkeleton>
    <div class="bl2-skeleton">
      <div class="bl2-shell">
        <div class="bl2-sk-hero">
          <div class="bl2-sk-copy">
            <div class="sk-line sk-w50"></div>
            <div class="sk-line sk-w80 sk-title"></div>
            <div class="sk-line sk-w70"></div>
            <div class="sk-line sk-w40"></div>
          </div>
          <div class="sk-thumb sk-large"></div>
        </div>
        <div class="bl2-sk-rail">
          <div class="sk-card" *ngFor="let n of [1, 2, 3, 4]">
            <div class="sk-thumb"></div>
            <div class="sk-line sk-w90 sk-mt"></div>
            <div class="sk-line sk-w70 sk-mt"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
